// actions.js
import { GET_ALL_COMPANIES, GET_ALL_COMPANIES_SUCCCESS, GET_ALL_COMPANIES_ERROR, GET_ALL_DEALERSHIPS, GET_ALL_DEALERSHIPS_SUCCCESS, GET_ALL_DEALERSHIPS_ERROR, GET_ALL_DEALERSHIPS_USERS, GET_ALL_DEALERSHIPS_USERS_SUCCCESS, GET_ALL_DEALERSHIPS_USERS_ERROR, GET_ALL_BRANDS_SUCCCESS, GET_ALL_BRANDS_ERROR, GET_FUEL_SUCCCESS, GET_FUEL_ERROR, GET_ALL_TRANSMISSION_SUCCCESS, GET_ALL_TRANSMISSION_ERROR, GET_ALL_MODELS, GET_ALL_MODELS_SUCCCESS, GET_ALL_MODELS_ERROR, GET_ALL_VARIANTS, GET_ALL_VARIANTS_SUCCCESS, GET_ALL_VARIANTS_ERROR, GET_ALL_DMS_DATA, GET_ALL_DMS_DATA_SUCCCESS, GET_ALL_DMS_DATA_ERROR, GET_ALL_DEALERSHIPS_LOADING, GET_ALL_BRANDS } from '../actionTypes'

export const getAllCompaniesData = (page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading) => ({
  type: GET_ALL_COMPANIES,
  payload: { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } 
});

export const getAllCompaniesDataSuccess = (data) => ({
  type: GET_ALL_COMPANIES_SUCCCESS,
  payload: data,
});

export const getAllCompaniesDataError = (error) => ({
  type: GET_ALL_COMPANIES_ERROR,
  payload: error,
});


export const getAllDealerShipsDataLoading = () => ({
  type: GET_ALL_DEALERSHIPS_LOADING,
});
export const getAllDealerShipsData = (page, rowsPerPage, searchText, columnFilters, sorting,setCount,setIsLoading) => ({
  type: GET_ALL_DEALERSHIPS,
  payload: {page, rowsPerPage, searchText, columnFilters, sorting,setCount, setIsLoading } 
});

export const getAllDealerShipsDataSuccess = (data) => ({
  type: GET_ALL_DEALERSHIPS_SUCCCESS,
  payload: data,
});

export const getAllDealerShipsDataError = (error) => ({
  type: GET_ALL_DEALERSHIPS_ERROR,
  payload: error,
});


export const getAllDealerShipsDataUsers = (dataHolder,currentPage,setcurrentPage,setTotalData,setDataHolder,settotalPage,getCount) => ({
  type: GET_ALL_DEALERSHIPS_USERS,
  payload: { dataHolder,currentPage,setcurrentPage,setTotalData,setDataHolder,settotalPage,getCount } 
});

export const getAllDealerShipsDataUsersSuccess = (data) => ({
  type: GET_ALL_DEALERSHIPS_USERS_SUCCCESS,
  payload: data,
});

export const getAllDealerShipsDataUsersError = (error) => ({
  type: GET_ALL_DEALERSHIPS_USERS_ERROR,
  payload: error,
});


export const getAllBrandsData = (page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading) => ({
  type: GET_ALL_BRANDS,
  payload: { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } 
});

export const getAllBrandsDataSuccess = (data) => ({
  type: GET_ALL_BRANDS_SUCCCESS,
  payload: data,
});

export const getAllBrandsDataError = (error) => ({
  type: GET_ALL_BRANDS_ERROR,
  payload: error,
});

// export const getFuelsData = (page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading) => ({
//   type: GET_FUEL,
//   payload: { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } 
// });

export const getFuelsDataSuccess = (data) => ({
  type: GET_FUEL_SUCCCESS,
  payload: data,
});

export const getFuelsDataError = (error) => ({
  type: GET_FUEL_ERROR,
  payload: error,
});


// export const getAllTransmissionData = (page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading) => ({
//   type: GET_ALL_TRANSMISSION,
//   payload: { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } 
// });

export const getAllTransmissionDataSuccess = (data) => ({
  type: GET_ALL_TRANSMISSION_SUCCCESS,
  payload: data,
});

export const getAllTransmissionDataError = (error) => ({
  type: GET_ALL_TRANSMISSION_ERROR,
  payload: error,
});


export const getModelsData = (page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading) => ({
  type: GET_ALL_MODELS,
  payload: { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } 
});

export const getModelsDataSuccess = (data) => ({
  type: GET_ALL_MODELS_SUCCCESS,
  payload: data,
});

export const getModelsDataError = (error) => ({
  type: GET_ALL_MODELS_ERROR,
  payload: error,
});


export const getVariantsData = (page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading) => ({
  type: GET_ALL_VARIANTS,
  payload: { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } 
});

export const getVariantsDataSuccess = (data) => ({
  type: GET_ALL_VARIANTS_SUCCCESS,
  payload: data,
});

export const getVariantsDataError = (error) => ({
  type: GET_ALL_VARIANTS_ERROR,
  payload: error,
});

export const getDMSData = () => ({
  type: GET_ALL_DMS_DATA,
});

export const getDMSDataSuccess = (data) => ({
  type: GET_ALL_DMS_DATA_SUCCCESS,
  payload: data,
});

export const getDMSDataError = (error) => ({
  type: GET_ALL_DMS_DATA_ERROR,
  payload: error,
});
